/**
 * Context for opening profile and team stats in a modal (popup) instead of navigating.
 */

import React, { createContext, useContext, useState, useCallback } from 'react';

const StatsModalContext = createContext(null);

export function useStatsModal() {
  const ctx = useContext(StatsModalContext);
  return ctx;
}

const initialState = { type: null, userId: null, playerIds: null };

export function StatsModalProvider({ children }) {
  const [state, setState] = useState(initialState);

  const openProfileModal = useCallback((userId) => {
    if (!userId) return;
    setState({ type: 'profile', userId, playerIds: null });
  }, []);

  const openTeamStatsModal = useCallback((playerIds) => {
    const ids = Array.isArray(playerIds) ? playerIds.filter(Boolean) : [];
    if (ids.length === 0) return;
    setState({ type: 'team', userId: null, playerIds: ids });
  }, []);

  const closeModal = useCallback(() => {
    setState(initialState);
  }, []);

  return (
    <StatsModalContext.Provider
      value={{
        profileUserId: state.type === 'profile' ? state.userId : null,
        teamPlayerIds: state.type === 'team' ? state.playerIds : null,
        openProfileModal,
        openTeamStatsModal,
        closeModal,
      }}
    >
      {children}
    </StatsModalContext.Provider>
  );
}
